import { readSelectedAiSelfieArtFromStorage } from "../services/stylePromptResolver";
import {
  readActiveStoredStation,
  type StoredStationRecord,
} from "./stationFlowStorage";

/**
 * Resolves full-screen theme background for shared flow pages
 * (choose-option, upload QR, transformation, result).
 *
 * Prefers API `inner_bg_image`, then `background_image` / `backgroundImageUrl`
 * from the active station or selected art. No static local fallbacks.
 */
export function resolveStationThemeBackground(
  station?: StoredStationRecord | null
): string {
  const activeStation = station ?? readActiveStoredStation();
  let selectedArt: {
    inner_bg_image?: string | null;
    background_image?: string | null;
    category?: {
      inner_bg_image?: string | null;
      background_image?: string | null;
    } | null;
  } | null = null;

  try {
    selectedArt = readSelectedAiSelfieArtFromStorage();
  } catch {
    // Ignore storage parse errors and continue with station fallback.
  }

  // Prefer selected art so switching arts (e.g. wynwood → hobby) updates the BG.
  return (
    selectedArt?.inner_bg_image?.trim() ||
    selectedArt?.category?.inner_bg_image?.trim() ||
    selectedArt?.background_image?.trim() ||
    selectedArt?.category?.background_image?.trim() ||
    activeStation?.inner_bg_image?.trim() ||
    activeStation?.background_image?.trim() ||
    activeStation?.backgroundImageUrl?.trim() ||
    ""
  );
}

/**
 * Logo for themed flow screens: always the selected art's `logo` from the API.
 * Returns "" when the selected art has no logo so callers can fall back.
 */
export function resolveStationThemeLogo(art?: {
  logo?: string | null;
  logo_url?: string | null;
} | null): string {
  let selectedArt = art;

  if (selectedArt === undefined) {
    try {
      selectedArt = readSelectedAiSelfieArtFromStorage();
    } catch {
      selectedArt = null;
    }
  }

  return selectedArt?.logo?.trim() || selectedArt?.logo_url?.trim() || "";
}
